import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { loadComissions, loadWallets, payVendor } from "../data/API";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import SearchField from "../mui/SearchField";
import { Toaster } from "react-hot-toast";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import dayjs from "dayjs";

function BasicTable({ list , getWallets}) {
  const [makePayment, setMakePayment] = useState(null);
  const [paidAmount, setPaidAmount] = React.useState("");
  const [tid, setTID] = React.useState("");


  // Function to handle input change and validate numeric input
  const handlePaidAmountChange = (event) => {
    const inputValue = event.target.value;

    // Check if the input is numeric or empty
    if (/^\d*\.?\d*$/.test(inputValue) || inputValue === "") {
      setPaidAmount(inputValue);
    }
  };
  const [selectedDate, setSelectedDate] = React.useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    const a = dayjs(date).format('MM/DD/YYYY hh:mm A')
    setSelectedDate(a);

  };


  function makePaymentNow(){
    if(paidAmount=='' || tid=='' || selectedDate==null){
      toast("Please fill form completely");
      return;
    }
    const data = {
      'amount':paidAmount,'tid':tid,'dateAndTime' :selectedDate,'wallet_id':makePayment.id
    }

    payVendor(data,(err,data)=>{
      getWallets();
    })

    setMakePayment(null);
   



  }

  return (
    <TableContainer component={Paper}>
      <Toaster />

      <Dialog
        open={makePayment}
        fullScreen
        onClose={() => setMakePayment(null)}
      >
        <DialogTitle className="bg-red-500 text-white">
          Enter Payment Details
        </DialogTitle>

        <DialogContent className="flex flex-col gap-3">
          <div className="mt-8 flex-col gap-4 flex">
            <div className="flex flex-row gap-3">
              <TextField
                fullWidth
                InputProps={{ sx: { borderRadius: 6, fontSize: 16 ,marginTop:1} }}
                color="error"
                placeholder="Please Enter Transaction ID"
                value={tid}
                onChange={(e)=>setTID(e.target.value)}
              />
              <TextField
                fullWidth
                InputProps={{
                  sx: { borderRadius: 6, fontSize: 16, marginTop: 1 },
                  inputProps: {
                    step: "any", // Allows decimal numbers
                    inputMode: "numeric",
                  },
                }}
                color="error"
                placeholder="Please Enter Paid Amount"
                value={paidAmount}
                onChange={handlePaidAmountChange}
              />
              <div className="w-full">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DateTimePicker"]}>
                    <DateTimePicker
                      onChange={handleDateChange}

                      sx={{ borderRadius: 6, fontSize: 16 }}
                      label="Select Transaction Time"
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
            </div>


          </div>

        </DialogContent>

        <DialogActions sx={{ paddingX: 10, paddingY: 5 }}>
          <Button
            sx={{ borderRadius: 10, textTransform: "capitalize", paddingX: 5 }}
            onClick={() => makePaymentNow()}
            variant="contained"
            color="success"
          >
            Make Payment
          </Button>
          <Button
            sx={{ borderRadius: 10, textTransform: "capitalize", paddingX: 5 }}
            onClick={() => setMakePayment(null)}
            variant="contained"
            color="error"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }}>ID</TableCell>
            <TableCell align="left" style={{ fontWeight: "bold" }}>
              Amount
            </TableCell>

            <TableCell align="left" style={{ fontWeight: "bold" }}>
              VENDOR ID
            </TableCell>
            <TableCell align="left" style={{ fontWeight: "bold" }}>
              Last Updated
            </TableCell>

            <TableCell align="left" style={{ fontWeight: "bold" }}>
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list?.map((row) => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.id}
              </TableCell>
              <TableCell align="left" style={{ color: "green" }}>
                {row.amount}RM
              </TableCell>
              <TableCell align="left">{row.kitchen_id}</TableCell>
              <TableCell align="left">
                {row.updated_at.replaceAll("T", " ").split(".")[0]}
              </TableCell>

              <TableCell align="left">
                <Button
                  onClick={() => setMakePayment(row)}
                  sx={{ fontSize: 10 }}
                  variant="contained"
                  color="success"
                >
                  Make Payment
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default function PendingPayments() {
  const [loading, setLoading] = useState(true);
  const [wallets, setWallets] = useState();

  function getWallets() {
    setLoading(true);
    loadWallets((err, data) => {
      if (err) {
        setLoading(false);
        console.log(err);
      } else {
        setLoading(false);
        setWallets(data);
      }
    });
  }

  useEffect(() => {
    getWallets();
  }, []);

  const [query, setQuery] = useState("");

  function getFilteredPayments() {
    var list = wallets.filter((e) => e.amount > 0);
    return list;
  }
  function getTotalComissions() {
    var t = 0;
    wallets.forEach((element) => {
      t += parseFloat(element.amount);
    });
    return t.toFixed(1);
  }

  function exportFile() {
    const list = getFilteredPayments();

    // Creating an object to represent the text
    const data = [];

    list.forEach((element) => {
      data.push({
        "Payment Mode": element.profile.bank_code=='BIMBMYKL'?'LIP':'LGP',
        "Benificiary Name": element.profile.owner_name,
        "Benificiary Account": element.profile.account_number,
        "Benificiary Bank Code": element.profile.bank_code,
        "Amount": parseFloat(element.amount).toFixed(0),
        "Payment Description": "Payment Distribution amoung partners",
        "Payment Reference": "Vendor:"+element.id,
        "Beneficiary New IC No": element.profile.nric_no,
        "Beneficiary Old IC No":"",
        "Beneficiary Business Registration":element.profile.account_type=="personal"?'':element.profile.company_reg_number,
        "Beneficiary Others":"",
        "Payment Advice Indicator":"B",
        "Mobile Phone No":element.profile.phone,
        'Beneficiary Email 1':element.profile.email,
        'Generic Payment Information':"Payment Reciept",
        'Invoice Date 1':dayjs(new Date()).format('DD/MM/YYYY'),
        'Invoice Amount 1':parseFloat(element.amount).toFixed(0),
        'Payment Amount 1':parseFloat(element.amount).toFixed(0),


      });
    });

    // Convert object to JSON string
    const jsonString = JSON.stringify(data);

    // const element = document.createElement('a');
    // const file = new Blob([jsonString], {type: 'application/json'});
    // element.href = URL.createObjectURL(file);
    // element.download = 'bulk_entries.json';
    // document.body.appendChild(element);
    // element.click();

    const json = data;

    const worksheet = XLSX.utils.json_to_sheet(json);

    // Make header row bold
    const headerRow = 1; // Header row is 1-based index
    for (let col = 0; col < Object.keys(json[0]).length; col++) {
      const cell = XLSX.utils.encode_cell({ r: headerRow, c: col });
      worksheet[cell].s = { font: { bold: true } }; // Apply bold style to each cell in header row
    }

    const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };

    const fileName = "excel_sheet.xlsx";

    const excelBuffer = XLSX.writeFileXLSX(workbook, fileName, {
      bookType: "xlsx",
      type: "array",
    });

    // //const fileName = "excel_sheet.xlsx";
    // const blob = new Blob([excelBuffer], {type: "application/octet-stream"});
    // FileSaver.saveAs(blob, fileName);
  }
  return (
    <div className="w-full flex  flex-col  min-h-64  justify-center items-center">
      {loading && (
        <div className="p-2  rounded-full border-[2px] h-20 w-20 flex justify-center items-center  ">
          <CircularProgress size={50} />
        </div>
      )}
      {wallets && (
        <div className="rounded-xl flex-row flex gap-10 w-full mt-5 mb-5 self-start p-4 shadow-sm bg-white ">
          <div>
            <strong className="text-[20px]">Total Pending Amount</strong>

            <br />

            <span className=" text-[30px] text-green-600 font-bold">
              {getTotalComissions()} RM
            </span>
          </div>
          <div className="w-[380px]">
            <SearchField
              w={700}
              setQuery={setQuery}
              query={query}
              placeholder={"Search with Vendor Id,User ID, Order ID"}
            />
          </div>
          <div className="w-[300px] mt-2">
            <Button onClick={exportFile} variant="contained">
              Download Bulk Input File
            </Button>
          </div>
        </div>
      )}

      {wallets && <BasicTable list={getFilteredPayments()} getWallets={getWallets} />}
    </div>
  );
}
